// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AdmissionSourceType,
    AdmissionSourceTypeFromJSON,
    AdmissionSourceTypeToJSON,
    AdmissionType,
    AdmissionTypeFromJSON,
    AdmissionTypeToJSON,
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ClassificationCodeType,
    ClassificationCodeTypeFromJSON,
    ClassificationCodeTypeToJSON,
    FacilityCodeType,
    FacilityCodeTypeFromJSON,
    FacilityCodeTypeToJSON,
    FrequencyCodeType,
    FrequencyCodeTypeFromJSON,
    FrequencyCodeTypeToJSON,
    HourType,
    HourTypeFromJSON,
    HourTypeToJSON,
    OccurrenceSpanType,
    OccurrenceSpanTypeFromJSON,
    OccurrenceSpanTypeToJSON,
    OccurrenceType,
    OccurrenceTypeFromJSON,
    OccurrenceTypeToJSON,
    PatientStatusType,
    PatientStatusTypeFromJSON,
    PatientStatusTypeToJSON,
    StateType,
    StateTypeFromJSON,
    StateTypeToJSON,
    SupportInstitutionalClaimTemplateBody,
    SupportInstitutionalClaimTemplateBodyFromJSON,
    SupportInstitutionalClaimTemplateBodyToJSON,
    SupportInstitutionalTemplateServiceLine,
    SupportInstitutionalTemplateServiceLineFromJSON,
    SupportInstitutionalTemplateServiceLineToJSON,
    TemplatePaperwork,
    TemplatePaperworkFromJSON,
    TemplatePaperworkToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportCreateInstitutionalClaimTemplatePayload
 */
export interface SupportCreateInstitutionalClaimTemplatePayload extends SupportInstitutionalClaimTemplateBody {
    /**
     * The patient control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f03aPcn?: string;
    /**
     * The medical record number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f03bMrn?: string;
    /**
     * 
     * OpenAPI data type: {FacilityCodeType}
     * @type {FacilityCodeType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f04TypeOfBill2ndDigitTypeOfFacilityCode?: FacilityCodeType;
    /**
     * 
     * OpenAPI data type: {ClassificationCodeType}
     * @type {ClassificationCodeType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f04TypeOfBill3rdDigitBillClassificationCode?: ClassificationCodeType;
    /**
     * 
     * OpenAPI data type: {FrequencyCodeType}
     * @type {FrequencyCodeType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f04TypeOfBill4thDigitFrequencyCode?: FrequencyCodeType;
    /**
     * Statement from date for the service covered on the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f06StatementFromDate?: string;
    /**
     * Statement through date for the service covered on the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f06StatementThroughDate?: string;
    /**
     * The admission date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f12AdmissionDate?: string;
    /**
     * 
     * OpenAPI data type: {HourType}
     * @type {HourType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f13AdmissionHour?: HourType;
    /**
     * 
     * OpenAPI data type: {AdmissionType}
     * @type {AdmissionType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f14AdmissionType?: AdmissionType;
    /**
     * 
     * OpenAPI data type: {AdmissionSourceType}
     * @type {AdmissionSourceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f15AdmissionSource?: AdmissionSourceType;
    /**
     * 
     * OpenAPI data type: {HourType}
     * @type {HourType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f16DischargeHour?: HourType;
    /**
     * 
     * OpenAPI data type: {PatientStatusType}
     * @type {PatientStatusType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f17PatientStatus?: PatientStatusType;
    /**
     * Condition code 1
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f18ConditionCode1?: string;
    /**
     * Condition code 2
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f19ConditionCode2?: string;
    /**
     * Condition code 3
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f20ConditionCode3?: string;
    /**
     * Condition code 4
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f21ConditionCode4?: string;
    /**
     * Condition code 5
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f22ConditionCode5?: string;
    /**
     * Condition code 6
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f23ConditionCode6?: string;
    /**
     * Condition code 7
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f24ConditionCode7?: string;
    /**
     * Condition code 8
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f25ConditionCode8?: string;
    /**
     * Condition code 9
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f26ConditionCode9?: string;
    /**
     * Condition code 10
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f27ConditionCode10?: string;
    /**
     * Condition code 11
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f28ConditionCode11?: string;
    /**
     * 
     * OpenAPI data type: {StateType}
     * @type {StateType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f29AccidentState?: StateType;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f31aOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f31aOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f31bOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f31bOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f32aOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f32aOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f32bOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f32bOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f33aOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f33aOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f33bOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f33bOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f34aOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f34aOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceType}
     * @type {OccurrenceType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f34bOccurrenceCode?: OccurrenceType;
    /**
     * Occurrence date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f34bOccurrenceDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceSpanType}
     * @type {OccurrenceSpanType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f35aOccurrenceSpanCode?: OccurrenceSpanType;
    /**
     * Occurrence from date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f35aOccurrenceFromDate?: string;
    /**
     * Occurrence through date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f35aOccurrenceThroughDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceSpanType}
     * @type {OccurrenceSpanType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f35bOccurrenceSpanCode?: OccurrenceSpanType;
    /**
     * Occurrence from date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f35bOccurrenceFromDate?: string;
    /**
     * Occurrence through date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f35bOccurrenceThroughDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceSpanType}
     * @type {OccurrenceSpanType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f36aOccurrenceSpanCode?: OccurrenceSpanType;
    /**
     * Occurrence from date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f36aOccurrenceFromDate?: string;
    /**
     * Occurrence through date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f36aOccurrenceThroughDate?: string;
    /**
     * 
     * OpenAPI data type: {OccurrenceSpanType}
     * @type {OccurrenceSpanType}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f36bOccurrenceSpanCode?: OccurrenceSpanType;
    /**
     * Occurrence from date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f36bOccurrenceFromDate?: string;
    /**
     * Occurrence through date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f36bOccurrenceThroughDate?: string;
    /**
     * Claim-level narrative
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f38ClaimNarrative?: string;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39aValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39aValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39bValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39bValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39cValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39cValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39dValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f39dValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40aValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40aValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40bValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40bValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40cValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40cValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40dValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f40dValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41aValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41aValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41bValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41bValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41cValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41cValueAmount?: Amount;
    /**
     * Value code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41dValueCode?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f41dValueAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportInstitutionalTemplateServiceLine>}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f42ClaimLines?: Array<SupportInstitutionalTemplateServiceLine>;
    /**
     * Prior authorization code A
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f63aTreatmentAuthorizationCode?: string;
    /**
     * Prior authorization code B
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f63bTreatmentAuthorizationCode?: string;
    /**
     * Prior authorization code C
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f63cTreatmentAuthorizationCode?: string;
    /**
     * The claim-level referral number.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    referralNumber?: string;
    /**
     * Principal diagnosis code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67PrincipalDiagnosisCode?: string;
    /**
     * Diagnosis code A
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67aOtherDiagnosisCode?: string;
    /**
     * Diagnosis code B
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67bOtherDiagnosisCode?: string;
    /**
     * Diagnosis code C
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67cOtherDiagnosisCode?: string;
    /**
     * Diagnosis code D
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67dOtherDiagnosisCode?: string;
    /**
     * Diagnosis code E
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67eOtherDiagnosisCode?: string;
    /**
     * Diagnosis code F
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67fOtherDiagnosisCode?: string;
    /**
     * Diagnosis code G
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67gOtherDiagnosisCode?: string;
    /**
     * Diagnosis code H
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67hOtherDiagnosisCode?: string;
    /**
     * Diagnosis code I
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67iOtherDiagnosisCode?: string;
    /**
     * Diagnosis code J
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67jOtherDiagnosisCode?: string;
    /**
     * Diagnosis code K
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67kOtherDiagnosisCode?: string;
    /**
     * Diagnosis code L
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67lOtherDiagnosisCode?: string;
    /**
     * Diagnosis code M
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67mOtherDiagnosisCode?: string;
    /**
     * Diagnosis code N
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67nOtherDiagnosisCode?: string;
    /**
     * Diagnosis code O
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67oOtherDiagnosisCode?: string;
    /**
     * Diagnosis code P
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67pOtherDiagnosisCode?: string;
    /**
     * Diagnosis code Q
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f67qOtherDiagnosisCode?: string;
    /**
     * Admitting diagnosis code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f69AdmittingDiagnosisCode?: string;
    /**
     * Patient reason diagnosis code for visit
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f70aPatientReasonForVisitCode?: string;
    /**
     * Patient reason diagnosis code for visit
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f70bPatientReasonForVisitCode?: string;
    /**
     * Patient reason diagnosis code for visit
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f70cPatientReasonForVisitCode?: string;
    /**
     * ICD Diagnosis Code pertaining to external cause of injuries
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f72aExternalCauseOfInjuryCode?: string;
    /**
     * ICD Diagnosis Code pertaining to external cause of injuries
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f72bExternalCauseOfInjuryCode?: string;
    /**
     * ICD Diagnosis Code pertaining to external cause of injuries
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f72cExternalCauseOfInjuryCode?: string;
    /**
     * Principal procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74PrincipalProcedureCode?: string;
    /**
     * Principal procedure date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74PrincipalProcedureDate?: string;
    /**
     * Other procedure code A
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74aOtherProcedureCode?: string;
    /**
     * Other procedure date A
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74aOtherProcedureDate?: string;
    /**
     * Other procedure code B
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74bOtherProcedureCode?: string;
    /**
     * Other procedure date B
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74bOtherProcedureDate?: string;
    /**
     * Other procedure code C
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74cOtherProcedureCode?: string;
    /**
     * Other procedure date C
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74cOtherProcedureDate?: string;
    /**
     * Other procedure code D
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74dOtherProcedureCode?: string;
    /**
     * Other procedure date D
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74dOtherProcedureDate?: string;
    /**
     * Other procedure code E
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74eOtherProcedureCode?: string;
    /**
     * Other procedure date E
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    f74eOtherProcedureDate?: string;
    /**
     * Required when there is a paper attachment following this claim
     * OpenAPI data type: {array}
     * @type {Array<TemplatePaperwork>}
     * @memberof SupportCreateInstitutionalClaimTemplatePayload
     */
    x12Paperwork?: Array<TemplatePaperwork>;
}

export function SupportCreateInstitutionalClaimTemplatePayloadFromJSON(json: any): SupportCreateInstitutionalClaimTemplatePayload {
    return {
                'f03aPcn': !exists(json, 'f03aPcn') ? undefined : json['f03aPcn'],
                'f03bMrn': !exists(json, 'f03bMrn') ? undefined : json['f03bMrn'],
                'f04TypeOfBill2ndDigitTypeOfFacilityCode': !exists(json, 'f04TypeOfBill2ndDigitTypeOfFacilityCode') ? undefined : FacilityCodeTypeFromJSON(json['f04TypeOfBill2ndDigitTypeOfFacilityCode']),
                'f04TypeOfBill3rdDigitBillClassificationCode': !exists(json, 'f04TypeOfBill3rdDigitBillClassificationCode') ? undefined : ClassificationCodeTypeFromJSON(json['f04TypeOfBill3rdDigitBillClassificationCode']),
                'f04TypeOfBill4thDigitFrequencyCode': !exists(json, 'f04TypeOfBill4thDigitFrequencyCode') ? undefined : FrequencyCodeTypeFromJSON(json['f04TypeOfBill4thDigitFrequencyCode']),
                'f06StatementFromDate': !exists(json, 'f06StatementFromDate') ? undefined : json['f06StatementFromDate'],
                'f06StatementThroughDate': !exists(json, 'f06StatementThroughDate') ? undefined : json['f06StatementThroughDate'],
                'f12AdmissionDate': !exists(json, 'f12AdmissionDate') ? undefined : json['f12AdmissionDate'],
                'f13AdmissionHour': !exists(json, 'f13AdmissionHour') ? undefined : HourTypeFromJSON(json['f13AdmissionHour']),
                'f14AdmissionType': !exists(json, 'f14AdmissionType') ? undefined : AdmissionTypeFromJSON(json['f14AdmissionType']),
                'f15AdmissionSource': !exists(json, 'f15AdmissionSource') ? undefined : AdmissionSourceTypeFromJSON(json['f15AdmissionSource']),
                'f16DischargeHour': !exists(json, 'f16DischargeHour') ? undefined : HourTypeFromJSON(json['f16DischargeHour']),
                'f17PatientStatus': !exists(json, 'f17PatientStatus') ? undefined : PatientStatusTypeFromJSON(json['f17PatientStatus']),
                'f18ConditionCode1': !exists(json, 'f18ConditionCode1') ? undefined : json['f18ConditionCode1'],
                'f19ConditionCode2': !exists(json, 'f19ConditionCode2') ? undefined : json['f19ConditionCode2'],
                'f20ConditionCode3': !exists(json, 'f20ConditionCode3') ? undefined : json['f20ConditionCode3'],
                'f21ConditionCode4': !exists(json, 'f21ConditionCode4') ? undefined : json['f21ConditionCode4'],
                'f22ConditionCode5': !exists(json, 'f22ConditionCode5') ? undefined : json['f22ConditionCode5'],
                'f23ConditionCode6': !exists(json, 'f23ConditionCode6') ? undefined : json['f23ConditionCode6'],
                'f24ConditionCode7': !exists(json, 'f24ConditionCode7') ? undefined : json['f24ConditionCode7'],
                'f25ConditionCode8': !exists(json, 'f25ConditionCode8') ? undefined : json['f25ConditionCode8'],
                'f26ConditionCode9': !exists(json, 'f26ConditionCode9') ? undefined : json['f26ConditionCode9'],
                'f27ConditionCode10': !exists(json, 'f27ConditionCode10') ? undefined : json['f27ConditionCode10'],
                'f28ConditionCode11': !exists(json, 'f28ConditionCode11') ? undefined : json['f28ConditionCode11'],
                'f29AccidentState': !exists(json, 'f29AccidentState') ? undefined : StateTypeFromJSON(json['f29AccidentState']),
                'f31aOccurrenceCode': !exists(json, 'f31aOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f31aOccurrenceCode']),
                'f31aOccurrenceDate': !exists(json, 'f31aOccurrenceDate') ? undefined : json['f31aOccurrenceDate'],
                'f31bOccurrenceCode': !exists(json, 'f31bOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f31bOccurrenceCode']),
                'f31bOccurrenceDate': !exists(json, 'f31bOccurrenceDate') ? undefined : json['f31bOccurrenceDate'],
                'f32aOccurrenceCode': !exists(json, 'f32aOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f32aOccurrenceCode']),
                'f32aOccurrenceDate': !exists(json, 'f32aOccurrenceDate') ? undefined : json['f32aOccurrenceDate'],
                'f32bOccurrenceCode': !exists(json, 'f32bOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f32bOccurrenceCode']),
                'f32bOccurrenceDate': !exists(json, 'f32bOccurrenceDate') ? undefined : json['f32bOccurrenceDate'],
                'f33aOccurrenceCode': !exists(json, 'f33aOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f33aOccurrenceCode']),
                'f33aOccurrenceDate': !exists(json, 'f33aOccurrenceDate') ? undefined : json['f33aOccurrenceDate'],
                'f33bOccurrenceCode': !exists(json, 'f33bOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f33bOccurrenceCode']),
                'f33bOccurrenceDate': !exists(json, 'f33bOccurrenceDate') ? undefined : json['f33bOccurrenceDate'],
                'f34aOccurrenceCode': !exists(json, 'f34aOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f34aOccurrenceCode']),
                'f34aOccurrenceDate': !exists(json, 'f34aOccurrenceDate') ? undefined : json['f34aOccurrenceDate'],
                'f34bOccurrenceCode': !exists(json, 'f34bOccurrenceCode') ? undefined : OccurrenceTypeFromJSON(json['f34bOccurrenceCode']),
                'f34bOccurrenceDate': !exists(json, 'f34bOccurrenceDate') ? undefined : json['f34bOccurrenceDate'],
                'f35aOccurrenceSpanCode': !exists(json, 'f35aOccurrenceSpanCode') ? undefined : OccurrenceSpanTypeFromJSON(json['f35aOccurrenceSpanCode']),
                'f35aOccurrenceFromDate': !exists(json, 'f35aOccurrenceFromDate') ? undefined : json['f35aOccurrenceFromDate'],
                'f35aOccurrenceThroughDate': !exists(json, 'f35aOccurrenceThroughDate') ? undefined : json['f35aOccurrenceThroughDate'],
                'f35bOccurrenceSpanCode': !exists(json, 'f35bOccurrenceSpanCode') ? undefined : OccurrenceSpanTypeFromJSON(json['f35bOccurrenceSpanCode']),
                'f35bOccurrenceFromDate': !exists(json, 'f35bOccurrenceFromDate') ? undefined : json['f35bOccurrenceFromDate'],
                'f35bOccurrenceThroughDate': !exists(json, 'f35bOccurrenceThroughDate') ? undefined : json['f35bOccurrenceThroughDate'],
                'f36aOccurrenceSpanCode': !exists(json, 'f36aOccurrenceSpanCode') ? undefined : OccurrenceSpanTypeFromJSON(json['f36aOccurrenceSpanCode']),
                'f36aOccurrenceFromDate': !exists(json, 'f36aOccurrenceFromDate') ? undefined : json['f36aOccurrenceFromDate'],
                'f36aOccurrenceThroughDate': !exists(json, 'f36aOccurrenceThroughDate') ? undefined : json['f36aOccurrenceThroughDate'],
                'f36bOccurrenceSpanCode': !exists(json, 'f36bOccurrenceSpanCode') ? undefined : OccurrenceSpanTypeFromJSON(json['f36bOccurrenceSpanCode']),
                'f36bOccurrenceFromDate': !exists(json, 'f36bOccurrenceFromDate') ? undefined : json['f36bOccurrenceFromDate'],
                'f36bOccurrenceThroughDate': !exists(json, 'f36bOccurrenceThroughDate') ? undefined : json['f36bOccurrenceThroughDate'],
                'f38ClaimNarrative': !exists(json, 'f38ClaimNarrative') ? undefined : json['f38ClaimNarrative'],
                'f39aValueCode': !exists(json, 'f39aValueCode') ? undefined : json['f39aValueCode'],
                'f39aValueAmount': !exists(json, 'f39aValueAmount') ? undefined : AmountFromJSON(json['f39aValueAmount']),
                'f39bValueCode': !exists(json, 'f39bValueCode') ? undefined : json['f39bValueCode'],
                'f39bValueAmount': !exists(json, 'f39bValueAmount') ? undefined : AmountFromJSON(json['f39bValueAmount']),
                'f39cValueCode': !exists(json, 'f39cValueCode') ? undefined : json['f39cValueCode'],
                'f39cValueAmount': !exists(json, 'f39cValueAmount') ? undefined : AmountFromJSON(json['f39cValueAmount']),
                'f39dValueCode': !exists(json, 'f39dValueCode') ? undefined : json['f39dValueCode'],
                'f39dValueAmount': !exists(json, 'f39dValueAmount') ? undefined : AmountFromJSON(json['f39dValueAmount']),
                'f40aValueCode': !exists(json, 'f40aValueCode') ? undefined : json['f40aValueCode'],
                'f40aValueAmount': !exists(json, 'f40aValueAmount') ? undefined : AmountFromJSON(json['f40aValueAmount']),
                'f40bValueCode': !exists(json, 'f40bValueCode') ? undefined : json['f40bValueCode'],
                'f40bValueAmount': !exists(json, 'f40bValueAmount') ? undefined : AmountFromJSON(json['f40bValueAmount']),
                'f40cValueCode': !exists(json, 'f40cValueCode') ? undefined : json['f40cValueCode'],
                'f40cValueAmount': !exists(json, 'f40cValueAmount') ? undefined : AmountFromJSON(json['f40cValueAmount']),
                'f40dValueCode': !exists(json, 'f40dValueCode') ? undefined : json['f40dValueCode'],
                'f40dValueAmount': !exists(json, 'f40dValueAmount') ? undefined : AmountFromJSON(json['f40dValueAmount']),
                'f41aValueCode': !exists(json, 'f41aValueCode') ? undefined : json['f41aValueCode'],
                'f41aValueAmount': !exists(json, 'f41aValueAmount') ? undefined : AmountFromJSON(json['f41aValueAmount']),
                'f41bValueCode': !exists(json, 'f41bValueCode') ? undefined : json['f41bValueCode'],
                'f41bValueAmount': !exists(json, 'f41bValueAmount') ? undefined : AmountFromJSON(json['f41bValueAmount']),
                'f41cValueCode': !exists(json, 'f41cValueCode') ? undefined : json['f41cValueCode'],
                'f41cValueAmount': !exists(json, 'f41cValueAmount') ? undefined : AmountFromJSON(json['f41cValueAmount']),
                'f41dValueCode': !exists(json, 'f41dValueCode') ? undefined : json['f41dValueCode'],
                'f41dValueAmount': !exists(json, 'f41dValueAmount') ? undefined : AmountFromJSON(json['f41dValueAmount']),
                'f42ClaimLines': !exists(json, 'f42ClaimLines') ? undefined : (json['f42ClaimLines'] as Array<any>).map(SupportInstitutionalTemplateServiceLineFromJSON),
                'f63aTreatmentAuthorizationCode': !exists(json, 'f63aTreatmentAuthorizationCode') ? undefined : json['f63aTreatmentAuthorizationCode'],
                'f63bTreatmentAuthorizationCode': !exists(json, 'f63bTreatmentAuthorizationCode') ? undefined : json['f63bTreatmentAuthorizationCode'],
                'f63cTreatmentAuthorizationCode': !exists(json, 'f63cTreatmentAuthorizationCode') ? undefined : json['f63cTreatmentAuthorizationCode'],
                'referralNumber': !exists(json, 'referralNumber') ? undefined : json['referralNumber'],
                'f67PrincipalDiagnosisCode': !exists(json, 'f67PrincipalDiagnosisCode') ? undefined : json['f67PrincipalDiagnosisCode'],
                'f67aOtherDiagnosisCode': !exists(json, 'f67aOtherDiagnosisCode') ? undefined : json['f67aOtherDiagnosisCode'],
                'f67bOtherDiagnosisCode': !exists(json, 'f67bOtherDiagnosisCode') ? undefined : json['f67bOtherDiagnosisCode'],
                'f67cOtherDiagnosisCode': !exists(json, 'f67cOtherDiagnosisCode') ? undefined : json['f67cOtherDiagnosisCode'],
                'f67dOtherDiagnosisCode': !exists(json, 'f67dOtherDiagnosisCode') ? undefined : json['f67dOtherDiagnosisCode'],
                'f67eOtherDiagnosisCode': !exists(json, 'f67eOtherDiagnosisCode') ? undefined : json['f67eOtherDiagnosisCode'],
                'f67fOtherDiagnosisCode': !exists(json, 'f67fOtherDiagnosisCode') ? undefined : json['f67fOtherDiagnosisCode'],
                'f67gOtherDiagnosisCode': !exists(json, 'f67gOtherDiagnosisCode') ? undefined : json['f67gOtherDiagnosisCode'],
                'f67hOtherDiagnosisCode': !exists(json, 'f67hOtherDiagnosisCode') ? undefined : json['f67hOtherDiagnosisCode'],
                'f67iOtherDiagnosisCode': !exists(json, 'f67iOtherDiagnosisCode') ? undefined : json['f67iOtherDiagnosisCode'],
                'f67jOtherDiagnosisCode': !exists(json, 'f67jOtherDiagnosisCode') ? undefined : json['f67jOtherDiagnosisCode'],
                'f67kOtherDiagnosisCode': !exists(json, 'f67kOtherDiagnosisCode') ? undefined : json['f67kOtherDiagnosisCode'],
                'f67lOtherDiagnosisCode': !exists(json, 'f67lOtherDiagnosisCode') ? undefined : json['f67lOtherDiagnosisCode'],
                'f67mOtherDiagnosisCode': !exists(json, 'f67mOtherDiagnosisCode') ? undefined : json['f67mOtherDiagnosisCode'],
                'f67nOtherDiagnosisCode': !exists(json, 'f67nOtherDiagnosisCode') ? undefined : json['f67nOtherDiagnosisCode'],
                'f67oOtherDiagnosisCode': !exists(json, 'f67oOtherDiagnosisCode') ? undefined : json['f67oOtherDiagnosisCode'],
                'f67pOtherDiagnosisCode': !exists(json, 'f67pOtherDiagnosisCode') ? undefined : json['f67pOtherDiagnosisCode'],
                'f67qOtherDiagnosisCode': !exists(json, 'f67qOtherDiagnosisCode') ? undefined : json['f67qOtherDiagnosisCode'],
                'f69AdmittingDiagnosisCode': !exists(json, 'f69AdmittingDiagnosisCode') ? undefined : json['f69AdmittingDiagnosisCode'],
                'f70aPatientReasonForVisitCode': !exists(json, 'f70aPatientReasonForVisitCode') ? undefined : json['f70aPatientReasonForVisitCode'],
                'f70bPatientReasonForVisitCode': !exists(json, 'f70bPatientReasonForVisitCode') ? undefined : json['f70bPatientReasonForVisitCode'],
                'f70cPatientReasonForVisitCode': !exists(json, 'f70cPatientReasonForVisitCode') ? undefined : json['f70cPatientReasonForVisitCode'],
                'f72aExternalCauseOfInjuryCode': !exists(json, 'f72aExternalCauseOfInjuryCode') ? undefined : json['f72aExternalCauseOfInjuryCode'],
                'f72bExternalCauseOfInjuryCode': !exists(json, 'f72bExternalCauseOfInjuryCode') ? undefined : json['f72bExternalCauseOfInjuryCode'],
                'f72cExternalCauseOfInjuryCode': !exists(json, 'f72cExternalCauseOfInjuryCode') ? undefined : json['f72cExternalCauseOfInjuryCode'],
                'f74PrincipalProcedureCode': !exists(json, 'f74PrincipalProcedureCode') ? undefined : json['f74PrincipalProcedureCode'],
                'f74PrincipalProcedureDate': !exists(json, 'f74PrincipalProcedureDate') ? undefined : json['f74PrincipalProcedureDate'],
                'f74aOtherProcedureCode': !exists(json, 'f74aOtherProcedureCode') ? undefined : json['f74aOtherProcedureCode'],
                'f74aOtherProcedureDate': !exists(json, 'f74aOtherProcedureDate') ? undefined : json['f74aOtherProcedureDate'],
                'f74bOtherProcedureCode': !exists(json, 'f74bOtherProcedureCode') ? undefined : json['f74bOtherProcedureCode'],
                'f74bOtherProcedureDate': !exists(json, 'f74bOtherProcedureDate') ? undefined : json['f74bOtherProcedureDate'],
                'f74cOtherProcedureCode': !exists(json, 'f74cOtherProcedureCode') ? undefined : json['f74cOtherProcedureCode'],
                'f74cOtherProcedureDate': !exists(json, 'f74cOtherProcedureDate') ? undefined : json['f74cOtherProcedureDate'],
                'f74dOtherProcedureCode': !exists(json, 'f74dOtherProcedureCode') ? undefined : json['f74dOtherProcedureCode'],
                'f74dOtherProcedureDate': !exists(json, 'f74dOtherProcedureDate') ? undefined : json['f74dOtherProcedureDate'],
                'f74eOtherProcedureCode': !exists(json, 'f74eOtherProcedureCode') ? undefined : json['f74eOtherProcedureCode'],
                'f74eOtherProcedureDate': !exists(json, 'f74eOtherProcedureDate') ? undefined : json['f74eOtherProcedureDate'],
                'x12Paperwork': !exists(json, 'x12Paperwork') ? undefined : (json['x12Paperwork'] as Array<any>).map(TemplatePaperworkFromJSON),
        ...SupportInstitutionalClaimTemplateBodyFromJSON(json)
    };

}

export function SupportCreateInstitutionalClaimTemplatePayloadToForm(value?: SupportCreateInstitutionalClaimTemplatePayload): any {
    let jsonVal = SupportCreateInstitutionalClaimTemplatePayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportCreateInstitutionalClaimTemplatePayloadToJSON(value?: SupportCreateInstitutionalClaimTemplatePayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'f03aPcn': cleanupBlankValuesForBackend(value.f03aPcn),
            'f03bMrn': cleanupBlankValuesForBackend(value.f03bMrn),
            'f04TypeOfBill2ndDigitTypeOfFacilityCode': FacilityCodeTypeToJSON(value.f04TypeOfBill2ndDigitTypeOfFacilityCode),
            'f04TypeOfBill3rdDigitBillClassificationCode': ClassificationCodeTypeToJSON(value.f04TypeOfBill3rdDigitBillClassificationCode),
            'f04TypeOfBill4thDigitFrequencyCode': FrequencyCodeTypeToJSON(value.f04TypeOfBill4thDigitFrequencyCode),
            'f06StatementFromDate': cleanupBlankValuesForBackend(value.f06StatementFromDate),
            'f06StatementThroughDate': cleanupBlankValuesForBackend(value.f06StatementThroughDate),
            'f12AdmissionDate': cleanupBlankValuesForBackend(value.f12AdmissionDate),
            'f13AdmissionHour': HourTypeToJSON(value.f13AdmissionHour),
            'f14AdmissionType': AdmissionTypeToJSON(value.f14AdmissionType),
            'f15AdmissionSource': AdmissionSourceTypeToJSON(value.f15AdmissionSource),
            'f16DischargeHour': HourTypeToJSON(value.f16DischargeHour),
            'f17PatientStatus': PatientStatusTypeToJSON(value.f17PatientStatus),
            'f18ConditionCode1': cleanupBlankValuesForBackend(value.f18ConditionCode1),
            'f19ConditionCode2': cleanupBlankValuesForBackend(value.f19ConditionCode2),
            'f20ConditionCode3': cleanupBlankValuesForBackend(value.f20ConditionCode3),
            'f21ConditionCode4': cleanupBlankValuesForBackend(value.f21ConditionCode4),
            'f22ConditionCode5': cleanupBlankValuesForBackend(value.f22ConditionCode5),
            'f23ConditionCode6': cleanupBlankValuesForBackend(value.f23ConditionCode6),
            'f24ConditionCode7': cleanupBlankValuesForBackend(value.f24ConditionCode7),
            'f25ConditionCode8': cleanupBlankValuesForBackend(value.f25ConditionCode8),
            'f26ConditionCode9': cleanupBlankValuesForBackend(value.f26ConditionCode9),
            'f27ConditionCode10': cleanupBlankValuesForBackend(value.f27ConditionCode10),
            'f28ConditionCode11': cleanupBlankValuesForBackend(value.f28ConditionCode11),
            'f29AccidentState': StateTypeToJSON(value.f29AccidentState),
            'f31aOccurrenceCode': OccurrenceTypeToJSON(value.f31aOccurrenceCode),
            'f31aOccurrenceDate': cleanupBlankValuesForBackend(value.f31aOccurrenceDate),
            'f31bOccurrenceCode': OccurrenceTypeToJSON(value.f31bOccurrenceCode),
            'f31bOccurrenceDate': cleanupBlankValuesForBackend(value.f31bOccurrenceDate),
            'f32aOccurrenceCode': OccurrenceTypeToJSON(value.f32aOccurrenceCode),
            'f32aOccurrenceDate': cleanupBlankValuesForBackend(value.f32aOccurrenceDate),
            'f32bOccurrenceCode': OccurrenceTypeToJSON(value.f32bOccurrenceCode),
            'f32bOccurrenceDate': cleanupBlankValuesForBackend(value.f32bOccurrenceDate),
            'f33aOccurrenceCode': OccurrenceTypeToJSON(value.f33aOccurrenceCode),
            'f33aOccurrenceDate': cleanupBlankValuesForBackend(value.f33aOccurrenceDate),
            'f33bOccurrenceCode': OccurrenceTypeToJSON(value.f33bOccurrenceCode),
            'f33bOccurrenceDate': cleanupBlankValuesForBackend(value.f33bOccurrenceDate),
            'f34aOccurrenceCode': OccurrenceTypeToJSON(value.f34aOccurrenceCode),
            'f34aOccurrenceDate': cleanupBlankValuesForBackend(value.f34aOccurrenceDate),
            'f34bOccurrenceCode': OccurrenceTypeToJSON(value.f34bOccurrenceCode),
            'f34bOccurrenceDate': cleanupBlankValuesForBackend(value.f34bOccurrenceDate),
            'f35aOccurrenceSpanCode': OccurrenceSpanTypeToJSON(value.f35aOccurrenceSpanCode),
            'f35aOccurrenceFromDate': cleanupBlankValuesForBackend(value.f35aOccurrenceFromDate),
            'f35aOccurrenceThroughDate': cleanupBlankValuesForBackend(value.f35aOccurrenceThroughDate),
            'f35bOccurrenceSpanCode': OccurrenceSpanTypeToJSON(value.f35bOccurrenceSpanCode),
            'f35bOccurrenceFromDate': cleanupBlankValuesForBackend(value.f35bOccurrenceFromDate),
            'f35bOccurrenceThroughDate': cleanupBlankValuesForBackend(value.f35bOccurrenceThroughDate),
            'f36aOccurrenceSpanCode': OccurrenceSpanTypeToJSON(value.f36aOccurrenceSpanCode),
            'f36aOccurrenceFromDate': cleanupBlankValuesForBackend(value.f36aOccurrenceFromDate),
            'f36aOccurrenceThroughDate': cleanupBlankValuesForBackend(value.f36aOccurrenceThroughDate),
            'f36bOccurrenceSpanCode': OccurrenceSpanTypeToJSON(value.f36bOccurrenceSpanCode),
            'f36bOccurrenceFromDate': cleanupBlankValuesForBackend(value.f36bOccurrenceFromDate),
            'f36bOccurrenceThroughDate': cleanupBlankValuesForBackend(value.f36bOccurrenceThroughDate),
            'f38ClaimNarrative': cleanupBlankValuesForBackend(value.f38ClaimNarrative),
            'f39aValueCode': cleanupBlankValuesForBackend(value.f39aValueCode),
            'f39aValueAmount': AmountToJSON(value.f39aValueAmount),
            'f39bValueCode': cleanupBlankValuesForBackend(value.f39bValueCode),
            'f39bValueAmount': AmountToJSON(value.f39bValueAmount),
            'f39cValueCode': cleanupBlankValuesForBackend(value.f39cValueCode),
            'f39cValueAmount': AmountToJSON(value.f39cValueAmount),
            'f39dValueCode': cleanupBlankValuesForBackend(value.f39dValueCode),
            'f39dValueAmount': AmountToJSON(value.f39dValueAmount),
            'f40aValueCode': cleanupBlankValuesForBackend(value.f40aValueCode),
            'f40aValueAmount': AmountToJSON(value.f40aValueAmount),
            'f40bValueCode': cleanupBlankValuesForBackend(value.f40bValueCode),
            'f40bValueAmount': AmountToJSON(value.f40bValueAmount),
            'f40cValueCode': cleanupBlankValuesForBackend(value.f40cValueCode),
            'f40cValueAmount': AmountToJSON(value.f40cValueAmount),
            'f40dValueCode': cleanupBlankValuesForBackend(value.f40dValueCode),
            'f40dValueAmount': AmountToJSON(value.f40dValueAmount),
            'f41aValueCode': cleanupBlankValuesForBackend(value.f41aValueCode),
            'f41aValueAmount': AmountToJSON(value.f41aValueAmount),
            'f41bValueCode': cleanupBlankValuesForBackend(value.f41bValueCode),
            'f41bValueAmount': AmountToJSON(value.f41bValueAmount),
            'f41cValueCode': cleanupBlankValuesForBackend(value.f41cValueCode),
            'f41cValueAmount': AmountToJSON(value.f41cValueAmount),
            'f41dValueCode': cleanupBlankValuesForBackend(value.f41dValueCode),
            'f41dValueAmount': AmountToJSON(value.f41dValueAmount),
            'f42ClaimLines': (value.f42ClaimLines === undefined || value.f42ClaimLines === null) ? undefined  : (value.f42ClaimLines as Array<any>).map(SupportInstitutionalTemplateServiceLineToJSON),
            'f63aTreatmentAuthorizationCode': cleanupBlankValuesForBackend(value.f63aTreatmentAuthorizationCode),
            'f63bTreatmentAuthorizationCode': cleanupBlankValuesForBackend(value.f63bTreatmentAuthorizationCode),
            'f63cTreatmentAuthorizationCode': cleanupBlankValuesForBackend(value.f63cTreatmentAuthorizationCode),
            'referralNumber': cleanupBlankValuesForBackend(value.referralNumber),
            'f67PrincipalDiagnosisCode': cleanupBlankValuesForBackend(value.f67PrincipalDiagnosisCode),
            'f67aOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67aOtherDiagnosisCode),
            'f67bOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67bOtherDiagnosisCode),
            'f67cOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67cOtherDiagnosisCode),
            'f67dOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67dOtherDiagnosisCode),
            'f67eOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67eOtherDiagnosisCode),
            'f67fOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67fOtherDiagnosisCode),
            'f67gOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67gOtherDiagnosisCode),
            'f67hOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67hOtherDiagnosisCode),
            'f67iOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67iOtherDiagnosisCode),
            'f67jOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67jOtherDiagnosisCode),
            'f67kOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67kOtherDiagnosisCode),
            'f67lOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67lOtherDiagnosisCode),
            'f67mOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67mOtherDiagnosisCode),
            'f67nOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67nOtherDiagnosisCode),
            'f67oOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67oOtherDiagnosisCode),
            'f67pOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67pOtherDiagnosisCode),
            'f67qOtherDiagnosisCode': cleanupBlankValuesForBackend(value.f67qOtherDiagnosisCode),
            'f69AdmittingDiagnosisCode': cleanupBlankValuesForBackend(value.f69AdmittingDiagnosisCode),
            'f70aPatientReasonForVisitCode': cleanupBlankValuesForBackend(value.f70aPatientReasonForVisitCode),
            'f70bPatientReasonForVisitCode': cleanupBlankValuesForBackend(value.f70bPatientReasonForVisitCode),
            'f70cPatientReasonForVisitCode': cleanupBlankValuesForBackend(value.f70cPatientReasonForVisitCode),
            'f72aExternalCauseOfInjuryCode': cleanupBlankValuesForBackend(value.f72aExternalCauseOfInjuryCode),
            'f72bExternalCauseOfInjuryCode': cleanupBlankValuesForBackend(value.f72bExternalCauseOfInjuryCode),
            'f72cExternalCauseOfInjuryCode': cleanupBlankValuesForBackend(value.f72cExternalCauseOfInjuryCode),
            'f74PrincipalProcedureCode': cleanupBlankValuesForBackend(value.f74PrincipalProcedureCode),
            'f74PrincipalProcedureDate': cleanupBlankValuesForBackend(value.f74PrincipalProcedureDate),
            'f74aOtherProcedureCode': cleanupBlankValuesForBackend(value.f74aOtherProcedureCode),
            'f74aOtherProcedureDate': cleanupBlankValuesForBackend(value.f74aOtherProcedureDate),
            'f74bOtherProcedureCode': cleanupBlankValuesForBackend(value.f74bOtherProcedureCode),
            'f74bOtherProcedureDate': cleanupBlankValuesForBackend(value.f74bOtherProcedureDate),
            'f74cOtherProcedureCode': cleanupBlankValuesForBackend(value.f74cOtherProcedureCode),
            'f74cOtherProcedureDate': cleanupBlankValuesForBackend(value.f74cOtherProcedureDate),
            'f74dOtherProcedureCode': cleanupBlankValuesForBackend(value.f74dOtherProcedureCode),
            'f74dOtherProcedureDate': cleanupBlankValuesForBackend(value.f74dOtherProcedureDate),
            'f74eOtherProcedureCode': cleanupBlankValuesForBackend(value.f74eOtherProcedureCode),
            'f74eOtherProcedureDate': cleanupBlankValuesForBackend(value.f74eOtherProcedureDate),
            'x12Paperwork': (value.x12Paperwork === undefined || value.x12Paperwork === null) ? undefined  : (value.x12Paperwork as Array<any>).map(TemplatePaperworkToJSON),
            ...SupportInstitutionalClaimTemplateBodyToJSON(value)
    };
}


